<template>
  <g
    :id="node.id"
    class="node"
    @click="$emit('click', $event, node)"
    @contextmenu.prevent="$emit('contextmenu', $event, node)"
    @focus="onNodeFocus"
    @blur="onNodeBlur"
  >
    <!-- Resize Frame -->

    <ResizeFrame
      ref="resizeFrame"
      :node="node"
      :visibleOption="visibleOption"
    />

    <g :id="`${node.id}-node`"  >
      <!-- Node -->
      <!-- <rect
        :id="`${node.id}-shape`"
        :x="node.x"
        :y="node.y"
       
        :width="node.width"
        :height="node.height"
        :fill="backgroundColor"
        :stroke="borderColor"
        :stroke-width="borderWidth"
      >
      </rect>
       -->

      <!-- Node Content -->
      <foreignObject
        class="node_content"
        v-if="!node.element"
        :x="node.x + 5"
        :y="node.y + 5"
        :width="node.width - 10"
        :height="node.height - 10"
      >
        <!-- <div class="image_item_plan_container"> -->
        
          <svg  viewBox="0 0 460 460" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
            <!-- Background -->
            <!-- Chairs (partially inside table) -->
            <circle cx="256" cy="100" r="40" :fill="`${reservations_data[node.DiningTableID]?'#4da1ff':'#264740'}`" fill-opacity="0.6"/>
            <circle cx="360" cy="152" r="40" :fill="`${reservations_data[node.DiningTableID]?'#4da1ff':'#264740'}`" fill-opacity="0.6"/>
            <circle cx="360" cy="360" r="40" :fill="`${reservations_data[node.DiningTableID]?'#4da1ff':'#264740'}`" fill-opacity="0.6"/>
            <circle cx="256" cy="412" r="40" :fill="`${reservations_data[node.DiningTableID]?'#4da1ff':'#264740'}`" fill-opacity="0.6"/>
            <circle cx="152" cy="360" r="40" :fill="`${reservations_data[node.DiningTableID]?'#4da1ff':'#264740'}`" fill-opacity="0.6"/>
            <circle cx="152" cy="152" r="40" :fill="`${reservations_data[node.DiningTableID]?'#4da1ff':'#264740'}`" fill-opacity="0.6"/>

            <!-- Central table (on top of chairs) -->
            <circle :class="`${reservations_data[node.DiningTableID]?'pulse_table':''}`" cx="256" cy="256" r="130" width="130" height="130" :fill="`${reservations_data[node.DiningTableID]?'#4da1ff':'#1b3230'}`"/>

            <!-- Text -->
            <template v-if="reservations_data[node.DiningTableID]">
              <text x="256" y="215" text-anchor="middle" font-family="Arial" font-size="43" style="font-size: 43px !important;" fill="#fff">{{ node.name }}</text>
              <text x="256" y="265" text-anchor="middle" font-family="Arial" font-size="30" style="font-size: 30px !important;"  fill="#fff">{{ reservations_data[node.DiningTableID].GuestName.split("|")[0] }} {{ reservations_data[node.DiningTableID].GuestName.split("|")[1] }}</text>
              <text x="256" y="310" text-anchor="middle" font-family="Arial" font-size="30" style="font-size: 30px !important;"  fill="#fff">{{ reservations_data[node.DiningTableID].heure }}</text>
          </template>
          <template v-else>
            <text x="256" y="265" text-anchor="middle" font-family="Arial" font-size="43"  style="font-size: 43px !important;" fill="#fff">{{ node.name }}</text>
          </template>
          </svg>


        <!-- </div> -->
      </foreignObject>

      <foreignObject
        v-else
        :x="node.x + 5"
        :y="node.y + 5"
        :width="node.width - 10"
        :height="node.height - 10"
      >
        <div class="image_item_plan_container">
          <img :src="node.image.replace('192.168.10.51','192.168.10.59').replace('localhost','192.168.10.59')" style="width: 90%" class="" alt="" srcset="" />
        </div>
      </foreignObject>

      <!-- Connectors -->
      <circle
        v-if="connectors.left"
        v-show="shouldDisplayRecieverConnector"
        :id="`${node.id}-connector-left`"
        :cx="connectors.left.x"
        :cy="connectors.left.y"
        r="7"
        class="connector"
        fill="#18A0FB"
        opacity="0.7"
        stroke="white"
        :key="`${node.id}-connector-left`"
        @mouseover="onConnectorMouseOver"
        @mouseleave="onConnectorMouseLeave"
        @mouseup="(e) => onConnectorMouseUp(e, connectors.left)"
      />
      <circle
        v-if="connectors.right"
        v-show="!connectingInfo.source && showConnector"
        :id="`${node.id}-connector-right`"
        :cx="connectors.right.x"
        :cy="connectors.right.y"
        r="7"
        class="connector"
        style="position: absolute"
        fill="#18A0FB"
        opacity="0.7"
        stroke="white"
        :key="`${node.id}-connector-right`"
        @mouseover="onConnectorMouseOver"
        @mouseleave="onConnectorMouseLeave"
        @mousedown="(e) => onConnectorClick(e, connectors.right)"
        @mousemove="(e) => e.stopPropagation()"
      />
    </g>
  </g>
</template>
<script>
import * as d3 from "d3";
import ResizeFrame from "./reize-frame.vue";

export default {
  data() {
    return {
      showConnector: false,
    };
  },
  computed: {
    connectors() {
      const halfWidth = this.node.width / 2;
      const halfHeight = this.node.height / 2;
      // let top = { x: node.x + halfWidth, y: node.y - 10 };
      let left = { x: this.node.x - 20, y: this.node.y + halfHeight };
      // let bottom = { x: node.x + halfWidth, y: node.y + node.height + 10 };
      let right = {
        x: this.node.x + this.node.width + 20,
        y: this.node.y + halfHeight,
      };

      if (this.node.type == "input") return { right };
      else if (this.node.type == "output") return { left };

      return { left, right };
    },
    shouldDisplayRecieverConnector() {
      return (
        this.connectingInfo.source &&
        this.connectingInfo.source.id != this.node.id
      );
    },
    borderWidth() {
      if (!this.node.style || !this.node.style.borderWidth) return "1px";

      return this.node.style.borderWidth;
    },
    borderColor() {
      if (!this.node.style || !this.node.style.borderColor) return "black";

      return this.node.style.borderColor;
    },
    backgroundColor() {
      if (!this.node.style || !this.node.style.backgroundColor) return "white";

      return this.node.style.backgroundColor;
    },
    color() {
      if (!this.node.style || !this.node.style.color) return "black";

      return this.node.style.color;
    },
    fontSize() {
      if (!this.node.style || !this.node.style.fontSize) return "12px";

      return this.node.style.fontSize;
    },
  },
  mounted() {
    // var drag = d3
    //   .drag()
    //   .on("start", this.onNodeDragStarted)
    //   .on("drag", this.onNodeDragged)
    //   .on("end", this.onNodeDragEnded);

    // d3.select(`[id='${this.node.id}-node'`).call(drag);
  },
  methods: {
    onNodeFocus(e) {
      e.stopPropagation();
      this.$refs.resizeFrame.show();
      this.showConnector = true;
      this.$emit("focus", e, this.node);
    },
    onNodeBlur(e) {
      e.stopPropagation();
      this.$refs.resizeFrame.hide();
      this.showConnector = false;
      this.$emit("blur", e, this.node);
    },
    onConnectorMouseOver(e) {
      d3.select(e.srcElement).attr("r", 10);
    },
    onConnectorMouseLeave(e) {
      d3.select(e.srcElement).attr("r", 7);
    },
    onConnectorClick(e, c) {
      e.stopPropagation();
      e.preventDefault();
      this.$emit("connecting", e, this.node, c);
    },
    onConnectorMouseUp(e, c) {
      this.$emit("connected", e, this.node, c);
    },
    onNodeDragStarted(e) {
      this.$emit("node-dragstart", this.node);
    },
    onNodeDragged(e) {
      if (this.connecting) return;
      this.node.x += e.dx;
      this.node.y += e.dy;
    },
    onNodeDragEnded(e) {
      if (this.connecting) return;
    },
  },
  watch: {},
  props: {
    node: {},
    reservations_data:Array,
    visibleOption: {
      type: Boolean,
      default: false,
    },
    connectingInfo: {
      type: Object,
    },
  },
  components: {
    ResizeFrame,
  },
};
</script>

<style src="../index.css"></style>

<style>
.image_item_plan_container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 0px;
  margin: 0px !important;
  width: 100%;
  height: 100%;
}
.image_item_plan_container svg {
  position: relative;
  left: 0%;
}
</style>